import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {store} from "../store/configureStore";

const MOBILE_BREAKPOINT = 768;

const HeaderContainer = () => {
	const navigate = useNavigate();
	const [menuDisplay, setMenuDisplay] = useState(false);
	const menuRef = useRef(null);
	const [isMobile, setIsMobile] = useState(
		typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
	);

	const user = store.getState().auth.user || {};

	useEffect(() => {
		const handleResize = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
		const handleClickOutside = (event) => {
			if (!menuRef.current) return;
			if (!menuRef.current.contains(event.target)) {
				setMenuDisplay(false);
			}
		};

		window.addEventListener("resize", handleResize);
		document.addEventListener("mousedown", handleClickOutside);
		handleResize();

		const notificationInterval = setInterval(() => {
			/* reserved for notification polling */
		}, 5000);

		return () => {
			window.removeEventListener("resize", handleResize);
			document.removeEventListener("mousedown", handleClickOutside);
			clearInterval(notificationInterval);
		};
	}, []);

	return (
		<div className={`fixed left-0 right-0 top-0 z-30 flex h-20 w-full items-center justify-between bg-[#1E1F21] ${isMobile ? "px-6" : "px-10"}`}>
			<button
				type="button"
				className="flex items-center"
				onClick={() => navigate("/dashboard")}
			>
				<svg width={45} height={44} fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M36.748.5H8.252A7.251 7.251 0 0 0 1 7.751v28.497A7.251 7.251 0 0 0 8.251 43.5H36.75A7.251 7.251 0 0 0 44 36.248V7.752A7.251 7.251 0 0 0 36.748.5Z"
						fill="#212529"
					/>
					<path
						d="M36.749.564H8.252A7.188 7.188 0 0 0 1.064 7.75v28.497a7.188 7.188 0 0 0 7.188 7.188h28.497a7.188 7.188 0 0 0 7.187-7.188V7.752A7.188 7.188 0 0 0 36.75.564Z"
						stroke="#12B656"
						strokeWidth={0.544}
					/>
					<path
						d="M20.978 31.63c2.291-.555 4.91-2.206 5.481-3.792-.13.287-.377.601-.846.914-.758.506-1.716.762-2.849.762a7.025 7.025 0 0 1-2.681-.481 7.86 7.86 0 0 1-2.317-1.537 2.118 2.118 0 0 0-1.456-.557 2.205 2.205 0 0 0-1.616.7c-.421.418-.66.986-.665 1.58.004.598.234 1.172.643 1.608 1.364.63 3.757 1.42 6.306.802ZM28.605 11.775c-.943-.366-3.29-.636-5.707.604-2.188 1.124-3.818 3.174-3.569 3.618.185-.29.413-.547.679-.764.675-.468 1.633-.705 2.847-.705a6.767 6.767 0 0 1 2.441.502c.844.329 1.504.726 1.961 1.18l.034.033c.351.304.802.467 1.267.457a2.192 2.192 0 0 0 1.607-.686c.416-.414.65-.977.652-1.565 0-.715-.33-1.367-.983-1.94-.074-.07-.153-.14-.23-.207a5.066 5.066 0 0 0-.816-.45s-.094-.043-.183-.077Z"
						fill="#2DC02E"
						stroke="#fff"
						strokeWidth={0.054}
					/>
					<path
						d="M30.247 23.275a6.406 6.406 0 0 0-2.715-2.28c-1.073-.498-2.462-.935-4.118-1.296-1.511-.35-2.648-.77-3.379-1.251-.583-.384-.855-.905-.855-1.64a1.74 1.74 0 0 1 .286-.992c.513-1.14 1.287-2.313 3.466-3.437 2.405-1.24 4.742-.97 5.682-.604a5.037 5.037 0 0 1 .994.527 8.76 8.76 0 0 0-2.808-1.605 11.418 11.418 0 0 0-3.912-.67 10.382 10.382 0 0 0-4.177.814 7.001 7.001 0 0 0-3.014 2.41 6.309 6.309 0 0 0-1.11 3.68c0 2 .675 3.598 2.007 4.75 1.25 1.081 3.031 1.864 5.28 2.322 1.69.37 2.947.825 3.736 1.354a2.08 2.08 0 0 1 .986 1.815c.003.23-.044.457-.138.666-.57 1.586-3.19 3.237-5.48 3.792-2.55.617-4.942-.174-6.306-.803.09.1.185.194.287.282a11.06 11.06 0 0 0 3.582 2.219c1.244.455 2.686.686 4.285.686a10.124 10.124 0 0 0 4.152-.847 7.484 7.484 0 0 0 3.078-2.443 6.153 6.153 0 0 0 1.164-3.676c0-1.522-.328-2.792-.973-3.773Z"
						fill="#fff"
					/>
				</svg>
				{!isMobile ? <p className="ml-4 text-2xl font-semibold text-white">Admin Panel</p> : null}
			</button>

			<div ref={menuRef} className="relative flex items-center py-4">
				<button
					type="button"
					onClick={() => setMenuDisplay((prev) => !prev)}
					className="flex items-center"
				>
					<p className="text-white">Hello, {user.name}</p>
					<img
						src={user.artwork_url}
						alt="profile"
						className="ml-4 h-11 w-11 rounded-full border border-[#12B656] object-cover"
					/>
				</button>

				{menuDisplay ? (
					<div className="absolute right-0 top-[calc(100%+10px)] z-[5] w-[289px] rounded bg-white p-4 shadow-[0_2px_8px_rgba(0,0,0,0.08)]">
							<div className="mb-4 flex items-center">
								<div className="mr-4 flex h-10 w-10 items-center justify-center overflow-hidden rounded-full border border-[#DFE0EB]">
									<img src={user.artwork_url} alt="avatar" className="h-[38px] w-[38px] rounded-full object-cover" />
								</div>
								<div>
									<p className="text-base font-semibold">{user.name}</p>
									<p className="mt-1 font-semibold text-[#909090]">{user.email}</p>
								</div>
							</div>

							<button
								type="button"
								onClick={() => {
									setMenuDisplay(false);
									navigate("/settings");
								}}
								className="my-4 flex h-6 items-center"
							>
								<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										clipRule="evenodd"
										d="M12.8 2.996a1 1 0 0 1 .942.662l.508 1.416c.08.223.237.41.442.528l1.508.87a1 1 0 0 0 .677.119l1.48-.267a1 1 0 0 1 1.046.484l.8 1.38a1 1 0 0 1-.1 1.147l-.97 1.148a1 1 0 0 0-.238.647v1.74a1 1 0 0 0 .237.647l.971 1.148a1 1 0 0 1 .1 1.147l-.8 1.38a1 1 0 0 1-1.044.484l-1.48-.267a1 1 0 0 0-.678.118l-1.508.87a1.007 1.007 0 0 0-.442.529l-.508 1.415a1 1 0 0 1-.943.663h-1.6a1 1 0 0 1-.942-.663l-.508-1.415a1.01 1.01 0 0 0-.441-.528l-1.509-.87a1 1 0 0 0-.677-.119l-1.48.267a1 1 0 0 1-1.046-.484l-.8-1.38a1 1 0 0 1 .1-1.147l.971-1.148a1 1 0 0 0 .237-.647v-1.74a1 1 0 0 0-.237-.647l-.961-1.148a1 1 0 0 1-.1-1.147l.8-1.38a1 1 0 0 1 1.045-.484l1.48.267a1 1 0 0 0 .677-.118l1.509-.87a1.01 1.01 0 0 0 .441-.529l.508-1.416a1 1 0 0 1 .933-.662h1.6Z"
										stroke="#323232"
										strokeWidth={1.5}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<circle cx={12} cy={12} r={2.751} stroke="#323232" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" />
								</svg>
								<span className="ml-8 text-base font-semibold">Settings</span>
							</button>

							<button
								type="button"
								onClick={() => {
									setMenuDisplay(false);
									navigate("/help");
								}}
								className="my-4 flex h-6 items-center"
							>
								<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M9.685 9.685A2.181 2.181 0 0 1 11.9 7.998 2.137 2.137 0 0 1 14.151 10c0 1.505-2.15 2.001-2.15 3.001M12.125 15.752a.125.125 0 1 1-.25 0 .125.125 0 0 1 .25 0"
										stroke="#323232"
										strokeWidth={1.5}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										clipRule="evenodd"
										d="M4.629 17.16a9.018 9.018 0 1 1 2.21 2.212l-2.842.631.632-2.843Z"
										stroke="#323232"
										strokeWidth={1.5}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
								<span className="ml-8 text-base font-semibold">Help Center</span>
							</button>

							<button
								type="button"
								onClick={() => store.dispatch({type: "TOGGLE_AUTH", user: {}})}
								className="mt-4 flex h-6 items-center"
							>
								<svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
									<path
										clipRule="evenodd"
										d="m14.163 21 4.444-.988A1.777 1.777 0 0 0 20 18.277V5.766c0-.833-.579-1.555-1.392-1.735l-4.444-.988A1.778 1.778 0 0 0 12 4.779v14.486A1.777 1.777 0 0 0 14.163 21v0Z"
										stroke="#323232"
										strokeWidth={1.5}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
									<path
										d="M15 10.98v2M4 16v2.042a2 2 0 0 0 2 2h3M4 8V6a2 2 0 0 1 2-2h3M4 12h5M7 14l2-2-2-2"
										stroke="#323232"
										strokeWidth={1.5}
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
								<span className="ml-8 text-base font-semibold">Log out</span>
							</button>
						</div>
				) : null}
			</div>
		</div>
	);
};

export default HeaderContainer;
